import { CONFIG } from 'config';
import { iframeReplace } from 'core/iframe';

export function Events(props) {
    // console.log('Events', iframeReplace('https://100os.events'));
    iframeReplace(CONFIG.appLinks.events, '/home')();
    return null;
}
export default Events;
